const popSrc = "https://pay3.veritrans.co.jp/pop/v1/javascripts/pop.js";
const clientKey = process.env.REACT_APP_VERITRANS_CLIENT_KEY;

export const loadVeritransPopLibrary = () => {
  // return new Promise((resolve, reject) => {
  return new Promise((resolve) => {
    // Check if already loaded
    if (document.querySelector('script[src="' + popSrc + '"]')) {
      console.log('pop.js already loaded');
      return resolve("already loaded");
    }

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = popSrc;
    script.setAttribute("data-client-key", clientKey);

    script.onload = () => {
      console.log('pop.js load done');
      setTimeout(() => {
        console.log('pop.js ready');
        resolve("load done");
      }, 2000);
    };
    // script.onerror = () => reject(new Error("Failed to load library"));

    document.head.appendChild(script);
  });
};
